import { Action } from '../action.type';

export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';

export interface OpenSidebar extends Action<void> {
  type: typeof OPEN_SIDEBAR;
}

export interface CloseSidebar extends Action<void> {
  type: typeof CLOSE_SIDEBAR;
}
